import { z } from 'zod';

export const criterionRuleSchema = z.enum([
  'some-match',
  'none-match',
  'every-match',
]);
export type CriterionRuleInput = z.infer<typeof criterionRuleSchema>;

export const criterionSchema = z.object({
  question_id: z.number().int().positive(),
  rule: criterionRuleSchema,
  expected: z.array(
    z.union([
      z.string(),
      z.number(),
      z.boolean(),
    ])
  ),
});
export type CriterionInput = z.infer<typeof criterionSchema>;

export const contentCriterionActionSchema = z.object({
  name: z.string(),
  metadata: z.record(z.string(), z.union([z.string(), z.number(), z.boolean()])).optional(),
});

export const contentCriterionSchema = z.object({
  criteria: z.array(criterionSchema),
  action: contentCriterionActionSchema,
});
export type ContentCriterionInput = z.infer<typeof contentCriterionSchema>;
